export class ReportPaths {
  static report = '';
  static access = 'access';
  static reportOverview = 'overview';
  static confidence = 'confidence';
  static confusions = 'confusions';
  static human = 'human';
  static simulated = 'simulated';
  static participants = 'participants';
  static paths = 'paths';
  static addParticipant = 'participants/more';
  static humanParticipants = 'participants/human';
  static simulatedParticipants = 'participants/simulated';

  static goToReport(base: string) {
    return `${base}`;
  }

  static goToReportAccess(base: string) {
    return `${base}/access`;
  }

  static goToReportOverview(base: string) {
    return `${base}/${this.reportOverview}`;
  }

  static goToConfidence(base: string) {
    return `${base}/${this.confidence}`;
  }

  static goToConfusions(base: string) {
    return `${base}/${this.confusions}`;
  }

  static goToHumanParticipants(base: string) {
    return `${base}/${this.participants}/${this.human}`;
  }

  static goToSimulatedParticipants(base: string) {
    return `${base}/${this.participants}/${this.simulated}`;
  }

  static goToSinglePath(base: string, pathId: string) {
    return `${base}/${this.paths}/${pathId}`;
  }

  static goToSinglePathView(
    base: string,
    type: 'human' | 'simulated',
    pathId: string,
    viewId: string
  ) {
    return `${base}/${this.paths}/${type}/${pathId}/${viewId}`;
  }

  static goToSinglePathBreakdown(
    base: string,
    type: 'human' | 'simulated',
    pathId: string
  ) {
    return `${base}/${this.paths}/${type}/${pathId}/breakdown`;
  }
}
